import { useNavigate } from 'react-router-dom'
import Button from '../UI/Button'
import useMutateData from '../../hooks/useMutateData'
import { useContext, useEffect } from 'react'
import { authContext } from '../../context/auth-context'
import viewFileApi from '../../services/viewFileApi'
import ViewFileForm from '../ViewFileForm'

const CreateViewFile = () => {
  useEffect(() => {
    document.title = 'Create View File - Analog Group'
  }, [])

  const navigate = useNavigate()
  const { token } = useContext(authContext)

  const { mutate: createViewFile, isLoading } = useMutateData({
    key: 'view-files',
    mutationFn: viewFileApi.createViewFile,
    successMessage: 'View file has been created successfully',
  })

  const onSubmit = async values => {
    createViewFile(
      { values, token },
      {
        onSuccess: () => {
          navigate(-1)
        },
      }
    )
  }

  return (
    <div>
      <div>
        <h4 id='formTitle'>Create View File</h4>
        <Button onClickHandler={() => navigate(-1)} text='< Back' />
      </div>
      <ViewFileForm onSubmit={onSubmit} isLoading={isLoading} />
    </div>
  )
}

export default CreateViewFile